import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageTemplateInuse } from 'app/modules/catalog-cloud/interfaces/page-template-inuse.interface';
import { PageTemplateService } from 'app/modules/catalog-cloud/services/page-template.service';

@Component({
  selector: 'app-page-template-in-use',
  templateUrl: './page-template-in-use.component.html',
  styleUrl: './page-template-in-use.component.scss'
})
export class PageTemplateInUseComponent {
  idPageTemplate: string;
  @Input() templateInuse: PageTemplateInuse[];
  @Input() displayDialog: boolean = false;
  @Output() dialogClosed = new EventEmitter<void>();

  constructor(private pageTemplateService: PageTemplateService) {}
  getPageTemplateInUse(){
    this.pageTemplateService.pageTemplateIsInUse(this.idPageTemplate).subscribe((data) => {
      this.templateInuse = data;
      this.displayDialog = true;
    })
  }

  closeDialog() {
    this.displayDialog = false;
    this.dialogClosed.emit();
  }
}
